import i18n from 'i18next';

export default () => ([
  {
    id: 0,
    label: i18n.t('does-not-repeat'),
    value: null,
  },
  {
    id: 1,
    label: i18n.t('repeats-daily'),
    value: 'daily',
  },
  {
    id: 2,
    label: i18n.t('repeats-weekly'),
    value: 'weekly',
  },
  {
    id: 3,
    label: i18n.t('repeats-monthly'),
    value: 'monthly',
  },
]);
